/**
 * Database type.
 */
export type DatabaseType =
    "mysql"|
    "postgres"|
    "mariadb"|
    "sqlite"|
    "cordova"|
    "react-native"|
    "nativescript" |
    "sqljs"|
    "oracle"|
    "mssql"|
    "mongodb"|
    "expo";
